import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'antd'
import { ButtonProps } from 'antd/lib/button'

interface LinkButtonProps extends Omit<ButtonProps, 'onClick'> {
  to: string
  children: React.ReactNode
  linkStyle?: React.CSSProperties
  onClick?: () => void
}

const LinkButton: React.FC<LinkButtonProps> = ({ to, children, linkStyle, onClick, ...buttonProps }) => {
  const history = useHistory()

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    history.push(to)
  }

  return (
    <Button {...buttonProps} onClick={handleClick} style={linkStyle}>
      {children}
    </Button>
  )
}

export default LinkButton 